import { inject, Injectable } from '@angular/core';
import { ApiDataAccess } from '@softline/core';
import {
  SOFTLINE_API_CASH_REGISTER_ACCOUNT_COLLECTORS,
  SOFTLINE_API_POS_CUSTOMER_INFO,
} from '@softapps/wws/pos-core';
import { Collector } from '@softapps/wws/pos-core';
import { CustomerResponse } from '@softapps/core/customer-info';

@Injectable()
export class AccountRepository {
  readonly #dataAccess = inject(ApiDataAccess);

  async collectors(accountId: number): Promise<Collector[]> {
    return this.#dataAccess.get({
      path: SOFTLINE_API_CASH_REGISTER_ACCOUNT_COLLECTORS,
      pathParams: { id: accountId },
    });
  }

  async retrieve(accountId: number): Promise<CustomerResponse> {
    return this.#dataAccess.get({
      path: SOFTLINE_API_POS_CUSTOMER_INFO,
      pathParams: { id: accountId },
    });
  }
}
